import type { TPersonDeclarationQuestion } from '@doutorsim/shared/exposed/person-declarations'
import type { TExposedPersonOfficialAddressDTO } from '@doutorsim/shared/exposed/persons'

export type DeclarationQuestion = 'birth_date' | 'mother_name' | 'address' | 'income'
export type AddressSubField = keyof TExposedPersonOfficialAddressDTO

type RootRow = {
  key: DeclarationQuestion
  question: TPersonDeclarationQuestion & DeclarationQuestion
  label: string
  subField?: undefined
}

type AddressRow = {
  key: `address.${AddressSubField}`
  question: Extract<TPersonDeclarationQuestion, `address-${string}`>
  label: string
  subField: AddressSubField
}

export type RowConfig = RootRow | AddressRow

export const FIELD_CONFIG: RowConfig[] = [
  { key: 'birth_date', question: 'birth_date', label: 'Nascimento' },
  { key: 'mother_name', question: 'mother_name', label: 'Nome da mãe' },
  { key: 'income', question: 'income', label: 'Renda mensal' },
  { key: 'address.postcode', question: 'address-postcode', label: 'CEP', subField: 'postcode' },
  {
    key: 'address.thoroughfare',
    question: 'address-thoroughfare',
    label: 'Logradouro',
    subField: 'thoroughfare',
  },
  {
    key: 'address.premiseNumber',
    question: 'address-premise-number',
    label: 'Número',
    subField: 'premiseNumber',
  },
  {
    key: 'address.subPremise',
    question: 'address-sub-premise',
    label: 'Complemento',
    subField: 'subPremise',
  },
  { key: 'address.premise', question: 'address-premise', label: 'Bairro', subField: 'premise' },
  { key: 'address.locality', question: 'address-locality', label: 'Cidade', subField: 'locality' },
  {
    key: 'address.subdivisionId',
    question: 'address-subdivision-id',
    label: 'Estado',
    subField: 'subdivisionId',
  },
]

// Distinct root questions (birth_date, mother_name, income, address) Robbu
// asks on WhatsApp — used to gate "can confirm" in the UI.
export const UNIQUE_QUESTION_COUNT = 4
